import { useLaunchParams } from '@hooks/useLaunchParams'
import { useResponsiveLayout } from '@hooks/useResponsiveLayout'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'
import { useSelector } from 'react-redux'
import { resolveGameView, GAME_VIEW_STATUS } from '@core/appearance/resolveGameView'
import LaunchParamsNotice from './LaunchParamsNotice'
import GameNoticeOverlay from '@components/overlays/GameNoticeOverlay'
import PlayZone from './zones/PlayZone'
import ReplayZone from './zones/ReplayZone'

const { RESOLVING, INCOMPLETE } = INTERNAL_CONSTANTS.LAUNCH_STATUS

const GameBootstrap = () => {
  const { params, launchStatus, missingParams } = useLaunchParams()
  useResponsiveLayout()

  const device = useSelector((state) => state.layout.mode)
  const hasViewport = useSelector((state) => state.layout.dimensions.vw > 0)

  if (launchStatus === RESOLVING) {
    return <LaunchParamsNotice variant="loading" />
  }

  if (launchStatus === INCOMPLETE) {
    return <LaunchParamsNotice variant="missing" missingParams={missingParams} />
  }

  const { status, game, mode } = resolveGameView({ gameCode: params.gameCode, device })

  // Unknown game code — block here so the boot loader never mounts (otherwise it
  // sits on top and looks stuck). Game existence doesn't depend on the viewport.
  if (status === GAME_VIEW_STATUS.GAME_NOT_FOUND) {
    return <GameNoticeOverlay status={status} gameCode={params.gameCode} />
  }

  // The mode gate depends on the measured viewport; hold on the loader until the
  // responsive layout has run once so a valid game never flashes the notice.
  if (!hasViewport) {
    return <LaunchParamsNotice variant="loading" />
  }

  if (status === GAME_VIEW_STATUS.MODE_PROHIBITED) {
    return (
      <GameNoticeOverlay status={status} gameCode={params.gameCode} game={game} mode={mode} />
    )
  }

  return (
    <div className="game-bootstrap-outer-container">
      <div className="game-bootstrap-inner-container">
        {!params.replay ? <PlayZone /> : <ReplayZone />}
      </div>
    </div>
  )
}

export default GameBootstrap
